// @flow
import styled from 'styled-components';

export const TradeButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	button {
		margin: 0 2.5px;
	}
`;

export default TradeButtonsWrapper;


// WEBPACK FOOTER //
// ./src/components/PlayersTable/tradeButtonsWrapper.js